import { Injectable } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { HexaValidator } from "../validators/hexa";
import { JsonValidator } from "../validators/json";
import { LocationValidator } from "../validators/location";

// import { AngularFireDatabase } from 'angularfire2/database';
// import * as firebase from 'firebase/app';

@Injectable()
export class GenFormBuilder {
  constructor(private formBuilder: FormBuilder) { }

  public genInputLang(
    control: string,
    form: FormGroup,
    langDefault: string = null,
    defaultValue: { en: string, es: string } = null,
    isRequired: boolean = true,
  ) {
    form.addControl(
      control,
      this.formBuilder.group({
        en: new FormControl(
          defaultValue ? defaultValue.en : "",
          langDefault === "en" ?
            (isRequired ? Validators.required : Validators.nullValidator) :
            Validators.nullValidator,
        ),
        es: new FormControl(
          defaultValue ? defaultValue.es : "",
          langDefault === "es" ?
            (isRequired ? Validators.required : Validators.nullValidator) :
            Validators.nullValidator,
        ),
      }),
    );
  }

  public genGroupToggle(control: string, form: FormGroup, modules: any) {
    const newModules = {};
    modules.forEach((module) => {
      newModules[module] = new FormControl(false);
    });

    form.addControl(
      control,
      this.formBuilder.group(newModules),
    );
  }

  public genGroupString(control: string, form: FormGroup, modules: any) {
    const newModules = {};
    modules.forEach((module) => {
      newModules[module] = new FormControl("");
    });

    form.addControl(
      control,
      this.formBuilder.group(newModules),
    );
  }

  public genInputString(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null,
    minLength: number = 0,
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue ? defaultValue : "",
        Validators.compose([
          isRequired ? Validators.required : Validators.nullValidator,
          Validators.minLength(minLength),
        ],
        ),
      ),
    );
  }

  public genInputJSON(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: any = {},
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        isRequired ? JsonValidator.isJsonRequired : Validators.nullValidator,
      ),
    );
  }

  public genInputJSONLength(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: any = {},
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        isRequired ? JsonValidator.isJsonFiveLength : Validators.nullValidator,
      ),
    );
  }

  public genInputEmail(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null,
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue ? defaultValue : "",
        Validators.compose([
          Validators.email,
          isRequired ? Validators.required : Validators.nullValidator,
        ]),
      ),
    );
  }

  public genInputLatitude(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null,
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        Validators.compose([
          LocationValidator.latitude,
          isRequired ? Validators.required : Validators.nullValidator,
        ]),
      ),
    );
  }

  public genInputLongitude(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: string = null,
  ) {
    form.addControl(
      control,
      new FormControl(
        defaultValue ? defaultValue : "",
        Validators.compose([
          LocationValidator.longitude,
          isRequired ? Validators.required : Validators.nullValidator,
        ]),
      ),
    );
  }

  public genInputHexa(control: string, form: FormGroup, isRequired: boolean = false) {
    form.addControl(
      control,
      new FormControl(
        "",
        Validators.compose([
          HexaValidator.isHexa,
          isRequired ? Validators.required : null,
        ]),
      ),
    );
  }

  public genToggle(control: string, form: FormGroup, isRequired: boolean = false, defaultValue: boolean = false) {
    form.addControl(
      control,
      new FormControl(
        defaultValue,
        isRequired ? Validators.required : Validators.nullValidator,
      ),
    );
  }

  public genInputNumber(
    control: string,
    form: FormGroup,
    isRequired: boolean = false,
    defaultValue: number = null,
  ) {
    // TODO: Poner validador de number
    form.addControl(
      control,
      new FormControl(
        (defaultValue !== null) ? defaultValue : "",
        isRequired ? Validators.required : Validators.nullValidator,
      ),
    );
  }

  public genInputDate(control: string, form: FormGroup, isRequired: boolean = false) {
    // TODO: Poner validador de fechas
    form.addControl(
      control,
      new FormControl(
        "",
        Validators.compose([
          isRequired ? Validators.required : Validators.nullValidator,
        ]),
      ),
    );
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/form.ts